import { ITEM_TYPES } from './ItemTypes';
export var COMPONENT_ITEM_TYPES = [
    ITEM_TYPES.BREADCRUMBS_COMPONENT,
    ITEM_TYPES.VIDEO_COMPONENT,
    ITEM_TYPES.GIFT_CARD
];
